"use client";
import TokenBuildForm from "@/components/ui/form/buildForm/tokenBuildForm";
import { MODES } from "@/components/ui/launchingCards";
import { cn } from "@/lib/utils";
import { IconPlayerRecordFilled } from "@tabler/icons-react";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { Button } from "../ui/button/button";
import PillButton from "../ui/button/pillButton";
import { Card } from "../ui/card/card";
import TokenLaunchForm from "./tokenLaunch";

export default function TokenLaunchPath() {
  const pathname = usePathname();
  const activeMode = pathname.includes("degen") ? "degen" : "builder";
  const activeModeData = MODES[activeMode === "degen" ? 1 : 0];

  return (
    <div className="mt-12">
      <Card
        botttomGrid
        extraOverlay={""}
        pillMode={activeMode === "degen" ? "red" : "blue"}
      >
        <div className="flex flex-col gap-9 py-10">
          <div className={cn(`flex items-center justify-center p-1 gap-4`)}>
            <div
              className={cn(
                `bg-background border-2 flex rounded-full p-1`,
                activeModeData.borderColor
              )}
            >
              <PillButton
                bgColor={activeModeData.checkBg}
                className="md:w-14 w-10 md:h-14 h-10"
              >
                <Image
                  src={activeModeData.icon}
                  alt="pill icon"
                  width={48}
                  height={48}
                  className="object-contain"
                />
              </PillButton>
            </div>
            <h3 className="text-white sm:text-5xl text-3xl font-semibold">
              {activeModeData.name}
            </h3>
          </div>
          <div className="flex md:flex-row flex-col gap-6 mx-auto">
            {activeModeData.ButtonLabels.map((label, i) => (
              <Button
                key={i}
                className="py-4 px-5 text-xs rounded-[50px] border border-white/5 text-white font-medium lg:text-sm "
                style={{
                  background:
                    "linear-gradient(180deg, rgba(16, 14, 22, 0.48) 0%, rgba(20, 18, 26, 0.48) 100%)",
                }}
              >
                <span
                  className={cn(
                    "text-red-500 w-auto border-2 border-red-500/50 rounded-full mr-1 ",
                    activeMode === "builder"
                      ? "text-blue-500 border-blue-500"
                      : ""
                  )}
                >
                  <IconPlayerRecordFilled stroke={2} size={12} />
                </span>{" "}
                {label}
              </Button>
            ))}
          </div>
        </div>
      </Card>

      {activeMode === "degen" ? (
        <TokenLaunchForm />
      ) : activeMode === "builder" ? (
        <TokenBuildForm />
      ) : null}
    </div>
  );
}
